<!-- The ref attr used to find the swiper instance -->
<template>
  <swiper :options="swiperOption" ref="mySwiper" class="swiper-box" :class="{'hide': !isPdfActive}">
    <swiper-slide class="swiper-item">
      <button class="close-btn" @click="close">
        <svg style="width:28px;height:28px" viewBox="0 0 24 24">
          <path fill="#FFF" d="M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z" />
        </svg>
      </button>
      <img class="pdf-page"
          v-lazy="{
          src: '../../static/img/brochure-a.jpg',
          error: '',
          loading: '../../static/img/preload.gif'
        }"/>
    </swiper-slide>
    <swiper-slide class="swiper-item">
      <button class="close-btn" @click="close">
        <svg style="width:28px;height:28px" viewBox="0 0 24 24">
          <path fill="#FFF" d="M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z" />
        </svg>
      </button>
      <img class="pdf-page"
           v-lazy="{
          src: '../../static/img/brochure-b.jpg',
          error: '',
          loading: '../../static/img/preload.gif'
        }"/>
    </swiper-slide>
    <swiper-slide class="swiper-item">
      <button class="close-btn" @click="close">
        <svg style="width:28px;height:28px" viewBox="0 0 24 24">
          <path fill="#FFF" d="M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z" />
        </svg>
      </button>
      <img class="pdf-page"
           v-lazy="{
          src: '../../static/img/brochure-c.jpg',
          error: '',
          loading: '../../static/img/preload.gif'
        }"/>
    </swiper-slide>
    <swiper-slide class="swiper-item">
      <button class="close-btn" @click="close">
        <svg style="width:28px;height:28px" viewBox="0 0 24 24">
          <path fill="#FFF" d="M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z" />
        </svg>
      </button>
      <img class="pdf-page"
           v-lazy="{
          src: '../../static/img/brochure-d.jpg',
          error: '',
          loading: '../../static/img/preload.gif'
        }"/>
    </swiper-slide>
    <swiper-slide class="swiper-item">
      <button class="close-btn" @click="close">
        <svg style="width:28px;height:28px" viewBox="0 0 24 24">
          <path fill="#FFF" d="M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z" />
        </svg>
      </button>
      <img class="pdf-page"
           v-lazy="{
          src: '../../static/img/brochure-e.jpg',
          error: '',
          loading: '../../static/img/preload.gif'
        }"/>
    </swiper-slide>
    <swiper-slide class="swiper-item">
      <button class="close-btn" @click="close">
        <svg style="width:28px;height:28px" viewBox="0 0 24 24">
          <path fill="#FFF" d="M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z" />
        </svg>
      </button>
      <img class="pdf-page"
           v-lazy="{
          src: '../../static/img/brochure-f.jpg',
          error: '',
          loading: '../../static/img/preload.gif'
        }"/>
    </swiper-slide>
    <swiper-slide class="swiper-item">
      <button class="close-btn" @click="close">
        <svg style="width:28px;height:28px" viewBox="0 0 24 24">
          <path fill="#FFF" d="M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z" />
        </svg>
      </button>
      <img class="pdf-page"
           v-lazy="{
          src: '../../static/img/brochure-g.jpg',
          error: '',
          loading: '../../static/img/preload.gif'
        }"/>
    </swiper-slide>
    <swiper-slide class="swiper-item">
      <button class="close-btn" @click="close">
        <svg style="width:28px;height:28px" viewBox="0 0 24 24">
          <path fill="#FFF" d="M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z" />
        </svg>
      </button>
      <img class="pdf-page"
           v-lazy="{
          src: '../../static/img/brochure-h.jpg',
          error: '',
          loading: '../../static/img/preload.gif'
        }"/>
    </swiper-slide>
    <!-- Optional controls -->
    <div class="swiper-pagination"  slot="pagination"></div>
    <div class="swiper-button-prev" slot="button-prev"></div>
    <div class="swiper-button-next" slot="button-next"></div>
  </swiper>
</template>

<script>
  import { mapState } from 'vuex'
  export default {
    data () {
      return {
        swiperOption: {
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
          },
          pagination: {
            el: '.swiper-pagination',
            type: 'fraction'
          },
          modifierClass: 'swiper-pagination-fraction'
        }
      }
    },
    methods: {
      close: function () {
        this.$store.commit('hidePdf')
      }
    },
    computed: mapState({
      isPdfActive: 'isPdfActive'
    })
  }
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .swiper-box {
    width: 100vw;
    min-height: 100vh;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 4;
  }
  .hide {
    display: none;
  }
  .swiper-item {
    width: 100vw;
    height: 100vh;
    text-align: center;
    font-size: 18px ;
    background: #000;
    /* Center slide text vertically */
    display: -webkit-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    -webkit-justify-content: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    -webkit-align-items: center;
    align-items: center;
  }
  .pdf-page {
    max-width: 100%;
    max-height: 100%;
  }
  .swiper-pagination-fraction {
    color: #C5AE87;
    font-weight: 600;
  }
  .close-btn {
    color: white;
    position: absolute;
    top: 15px;
    right: 15px;
    z-index: 5;
    width: 40px;
    height: 40px;
    border: none;
    outline: none;
    background: none;
    -webkit-tap-highlight-color: transparent;
    cursor: pointer;
  }
  /*large screen*/
  @media screen and (min-width: 767px) {
    .close-btn {
      top: 25px;
      right: 35px;
    }
  }
</style>



// WEBPACK FOOTER //
// Pdf.vue?490914a3